import React from 'react';
import { slideGradient } from 'commonComponents/common';
import classNames from 'classnames';
import styles from './BaseStage.module.scss';

const BaseStage = ({ pageName, children, additionalClass }) => {
  const classes = classNames({
    [styles.BaseStage]: true,
    [styles[pageName]]: !!pageName,
    [additionalClass]: !!additionalClass
  });

  return (
    <>
      <header className={ classes }>
        { children }
      </header>
      { slideGradient }
    </>
  );
};

export default BaseStage;
